import { TimezoneOption } from "@platform/features/timezones/timezones.types";
import { Timeslot } from "../timeslots.types";
import { makeTimeslotFromId } from "./makeTimeslotFromId";
import calculateTimeslotId from "./calculateTimeslotId";
import createTimeslotId from "./createTimeslotId";

export type Args = {
  startHour: number;
  endHour: number;
  timezone: TimezoneOption;
  startDate: string;
};

export function makeTimeslotsForRange({
  startHour,
  endHour,
  timezone,
  startDate,
}: Args): Timeslot[] {
  if (!timezone) throw new Error("Timezone is required");
  if (!(startHour >= 0 && endHour <= 23 && startHour < endHour)) {
    throw new Error("Invalid hour range");
  }

  const slots: Timeslot[] = [];
  const offsetMinutes = timezone.offsetHours * 60;

  for (let localDayIndex = 0; localDayIndex < 7; localDayIndex++) {
    for (let localHour = startHour; localHour < endHour; localHour++) {
      for (const localMinute of [0, 30]) {
        // Local minutes since start of week
        const localMinutesTotal =
          localDayIndex * 24 * 60 + localHour * 60 + localMinute;

        // Convert to GMT minutes
        const gmtMinutesTotal = localMinutesTotal - offsetMinutes;

        // Normalize into 0..(7*24*60)
        const weekMinutes = 7 * 24 * 60;
        const adjusted =
          ((gmtMinutesTotal % weekMinutes) + weekMinutes) % weekMinutes;

        // Extract GMT day/hour/minute
        const gmtDayIndex = Math.floor(adjusted / (24 * 60));
        const gmtHour = Math.floor((adjusted % (24 * 60)) / 60);
        const gmtMinute = adjusted % 60;

        // Build slot id
        const id = createTimeslotId(
          calculateTimeslotId({
            dayIndex: gmtDayIndex,
            hour: gmtHour,
            minute: gmtMinute,
          })
        );

        // Let makeTimeslotFromId do the actual object construction
        slots.push(makeTimeslotFromId(id, startDate, timezone));
      }
    }
  }

  return slots;
}

export default makeTimeslotsForRange;
